<template>
  <div class="quick-add-form">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0">Custom Item</h6>
      <button type="button" class="btn btn-sm btn-outline-secondary" @click="$emit('cancel')">
        <i class="bi bi-arrow-left me-1"></i>Back to Search
      </button>
    </div>

    <!-- Item Basics -->
    <div class="mb-2">
      <label class="form-label small">Title <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-sm" v-model="form.title" required />
    </div>
    <div class="row g-2 mb-2">
      <div class="col-6">
        <label class="form-label small">SKU</label>
        <input type="text" class="form-control form-control-sm" v-model="form.sku" />
      </div>
      <div class="col-6">
        <label class="form-label small">Sale Price <span class="text-danger">*</span></label>
        <money-input v-model="form.unitPrice" class="form-control form-control-sm" />
      </div>
    </div>

    <!-- Source Info (collapsible) -->
    <div class="mt-3">
      <a href="#" class="small text-muted" @click.prevent="showSource = !showSource">
        <i class="bi" :class="showSource ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        Source Information (optional)
      </a>
      <div v-if="showSource" class="mt-2">
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="form-label small">Price Paid</label>
            <money-input v-model="form.sourcePrice" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small">Acquisition Date</label>
            <utc-date-input v-model="form.acquisitionDate" class="form-control form-control-sm" />
          </div>
        </div>
        <source-input v-model="form.sourceData" />
      </div>
    </div>

    <button type="button" class="btn btn-primary btn-sm w-100 mt-3" @click="commit" :disabled="!form.title || !form.unitPrice">
      Add to Order
    </button>
  </div>
</template>

<script setup>
import { reactive, ref, defineProps, defineEmits } from 'vue'
import MoneyInput from '@/app/components/Utils/MoneyInput.vue'
import UtcDateInput from '@/app/components/Utils/UtcDateInput.vue'
import SourceInput from '@/app/components/inventory/SourceInput.vue'

const props = defineProps({
  initialTitle: {
    type: String,
    default: ''
  },
  initialData: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['cancel', 'commit'])

const hasSourceData = props.initialData &&
  (props.initialData.source_price || props.initialData.acquisition_date ||
   props.initialData.source_category_id || props.initialData.source_location_id)

const showSource = ref(!!hasSourceData)

const form = reactive({
  title: props.initialData?.memo || props.initialTitle,
  sku: props.initialData?.SKU || '',
  unitPrice: props.initialData?.unit_price || 0,
  sourcePrice: props.initialData?.source_price || 0,
  acquisitionDate: props.initialData?.acquisition_date || null,
  sourceData: {
    source_category_id: props.initialData?.source_category_id || null,
    source_location_id: props.initialData?.source_location_id || null
  }
})

function commit() {
  if (!form.title || !form.unitPrice) return
  const sourcePrice = parseFloat(form.sourcePrice) || 0
  emit('commit', {
    memo: form.title,
    SKU: form.sku,
    cogs: sourcePrice,
    unit_price: parseFloat(form.unitPrice) || 0,
    source_price: sourcePrice,
    acquisition_date: form.acquisitionDate,
    source_category_id: form.sourceData.source_category_id,
    source_location_id: form.sourceData.source_location_id
  })
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/_variables-esc.scss';

.quick-add-form {
  padding: 0.75rem;
  background: $gray-100;
  border: 1px solid $gray-300;
  border-radius: 0.375rem;
}
</style>
